"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetSingularService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const verse_consensus_1 = require("@branch-ts/verse-consensus");
const web_consensus_1 = require("@branch-ts/web-consensus");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
// View state follows the fresh agreement, not the browser's previous account.
// Graph caches remain keyed by scope URI and are not deleted or migrated here.
let VersetSingularService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetSingularService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({ VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService });
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetSingularService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        get singular() { return this.view.singular; }
        async initialize() {
            const login = this.deps.VersetRequireLoginService;
            const agreement = login.agreement;
            const mainURI = agreement.particulars.versetWebapp.verse.userMainVerseURI;
            const scope = encodeURIComponent(JSON.stringify([agreement.vendor, agreement.signer, mainURI]));
            this.view = new web_consensus_1.WebSingularService({
                localStorage: login.localStorageProvider,
                sessionStorage: login.sessionStorageProvider,
                storageName: `singular-verset-production:${scope}`,
            });
            await this.view.initialize();
        }
        async welcome() {
            const mainURI = this.deps.VersetRequireLoginService.agreement.particulars.versetWebapp.verse.userMainVerseURI;
            await this.singular.welcome.welcome({
                defaultURI: mainURI,
                canRestore: uri => {
                    if (typeof uri !== "string")
                        return false;
                    const verse = verse_consensus_1.VerseProtocol.VerseURI.parse(uri);
                    const item = verse_consensus_1.VerseProtocol.VerseItemURI.parse(uri);
                    return !!(verse || item) && verse_consensus_1.VerseProtocol.VerseURI.build(verse || item) === mainURI;
                },
            });
        }
    };
    return VersetSingularService = _classThis;
})();
exports.VersetSingularService = VersetSingularService;
